import { apiFetch } from "@core/http";
import type { components } from "@core/types/openapi";

export type CodeToValidate = components["schemas"]["CodeToValidate"];
export type ValidationSummary = components["schemas"]["ValidationSummary"];

export interface ValidationsToday {
  items: ValidationSummary[];
  dayTotal: number;
  historyDays: number;
}

// SPEC-302 §6 (RF-VAL-15): sin `date`, el contrato devuelve el día de hoy.
// `limit` 50 alcanza para un mostrador — no hay paginación en esta pantalla.
export function listValidations(
  bearerToken: string,
): Promise<ValidationsToday> {
  return apiFetch<ValidationsToday>("/v1/validator/validations?limit=50", {
    bearerToken,
  });
}

// SPEC-302 §4/§5: una sola función para el lookup, sin importar si el
// código llegó por la hoja manual o por el escáner — el `entry` es lo único
// que distingue el canal (RF-VAL-14, RF-VAL-18) y solo importa para el
// contador de bloqueo del ingreso manual (criterio 5).
export function lookupCode(
  code: string,
  entry: "manual" | "scan",
  bearerToken: string,
): Promise<CodeToValidate> {
  return apiFetch<CodeToValidate>(
    `/v1/validator/codes/${encodeURIComponent(code)}?entry=${entry}`,
    { bearerToken },
  );
}
